import React from 'react';
import { Typography, Container, Box, Paper } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import { useLanguage } from '../LanguageContext';
import { translations } from '../translations';

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const GradientBox = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #1565C0 0%, #1976D2 100%)',
  borderRadius: theme.spacing(3),
  padding: theme.spacing(4),
  color: 'white',
  textAlign: 'center',
  boxShadow: '0 12px 40px rgba(21, 101, 192, 0.3)',
  animation: `${fadeIn} 0.8s ease-out`,
}));

const StoryCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.spacing(3),
  background: 'white',
  boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 16px 48px rgba(0,0,0,0.12)',
  }
}));

const AboutUsView = () => {
  const { language } = useLanguage();
  const t = translations[language].about;

  return (
    <Box sx={{
      bgcolor: '#f8f9fa',
      minHeight: 'calc(100vh - 100px)',
      py: 8,
      px: 2
    }}>
      <Container maxWidth='lg' sx={{ px: { xs: 0, sm: 2 } }}>
        {/* Hero Section */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant='h2'
            component='h1'
            gutterBottom
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
              color: 'black'
            }}
          >
            {t.title}
          </Typography>
          <Typography
            variant='h5'
            color='text.secondary'
            sx={{
              mb: 2,
              fontWeight: 400,
              fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }
            }}
          >
            {t.subtitle}
          </Typography>
        </Box>

        {/* Story Section */}
        <StoryCard elevation={0} sx={{ mb: 6 }}>
          {t.story.map((paragraph, index) => (
            <Typography
              key={index}
              variant='body1'
              paragraph
              sx={{
                lineHeight: 2,
                fontSize: '1.1rem',
                color: 'text.primary',
                textAlign: 'left'
              }}
            >
              {paragraph}
            </Typography>
          ))}
        </StoryCard>

        {/* Tagline Section */}
        <GradientBox sx={{ mb: 4 }}>
          <Typography
            variant='h4'
            fontWeight={700}
            sx={{
              mb: 2,
              fontSize: { xs: '1.5rem', md: '2rem' }
            }}
          >
            {t.tagline}
          </Typography>
        </GradientBox>
      </Container>
    </Box>
  );
};

export default AboutUsView;
